export enum ErrorMessage {
    NO_ROOM_PROVIDED = 'No room provided',
    NO_INSTALMENT_SELECTED = 'No instalment selected',
    NO_BOOKING_DETAILS_PROVIDED = 'No booking details provided',
    NO_TERM_DETAILS_SELECTED = 'No term details selected',
    AGREEMENTS_NOT_SIGNED = 'Agreements have not been signed',
    NO_VITA_REF = 'No Vita Ref provided',
    COULD_NOT_DETERMINE_TERM_LENGTH = 'Could not determine term length',
    NO_USER_SELECTED = 'No user selected',
    NO_PAYMENT_PLAN_PROVIDED = 'No payment plan provided',
    AUTH0_ID_ERROR = 'Unable to retrieve Auth0 user ID from session. Please ensure the user is authenticated.',
    AUTH0_METADATA_UPDATE_ERROR = 'Failed to update user metadata',
    AUTH0_LOGIN_ERROR = 'Error logging in',
    DUAL_OCCUPANT_INSUFFICIENT_METADATA = 'Not enough query data',
    AMEND_NOT_REQUESTED = 'No amend has been requested for this booking',
    AMEND_WINDOW_EXPIRED = 'The amendment window for this booking has expired',
    AMEND_ADMIN_FEE_REQUIRED = 'This amendment requires an admin fee to be paid',
    AMEND_ALREADY_PROCESSED = 'This booking has already been amended',
    AMEND_TOO_MANY_OCCUPANTS = 'This booking already has a dual occupant',
    AMEND_GENERIC_ERROR = 'Something went wrong making this amendment',
}
